<template lang="html">
  <div
    :class='{"tabs__light": mode === "light", "tabs__dark": mode === "dark"}'
  >
    <ul class="tabs__header">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        :class='{"tab__selected": (index == selectedIndex)}'
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        default: 'light'
      },
      initialTab: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        selectedIndex: 0,
        tabs: []
      }
    },
    created () {
      this.tabs = this.$children
    },
    mounted () {
      this.selectTab(this.initialTab)
    },
    methods: {
      selectTab (i) {
        this.selectedIndex = i

        this.tabs.forEach((tab, index) => {
          tab.isActive = (index === i)
        })
      }
    }
  }
</script>

<style lang="scss">
  ul.tabs__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin: 0 0 1.2rem 0;
    padding: 0.15rem 0 0.85rem;
    list-style: none;
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #dde5e0;
  }

  ul.tabs__header > li {
    border: none;
    background: transparent;
    color: #5f6f66;
    font-family: "Montserrat-Medium", "Montserrat", sans-serif;
    font-size: 1.15rem;
    font-weight: 500;
    padding: 0.65rem 1.75rem;
    margin: 0;
    display: inline-block;
    cursor: pointer;
    border-radius: 0.55rem;
    transition: color 0.15s ease, background-color 0.15s ease;
  }

  ul.tabs__header > li:hover {
    color: #005516;
    background: rgba(0, 85, 22, 0.06);
  }

  ul.tabs__header > li.tab__selected {
    color: #005516;
    background: transparent;
    font-family: "Montserrat-Bold", "Montserrat", sans-serif;
    font-weight: 700;
    box-shadow: inset 0 -3px 0 #ffa600;
  }

  .tab {
    color: #1f2d24;
    padding: 0;
    border-radius: 0.55rem;
    min-height: 400px;
  }

  /* Mantém modo dark caso ainda seja usado em algum lugar */
  .tabs__dark .tab {
    background-color: #555;
    color: #eee;
  }

  .tabs__dark ul.tabs__header {
    background: #444;
    border-color: #666;
  }

  .tabs__dark li {
    background-color: transparent;
    color: #bbb;
  }

  .tabs__dark li.tab__selected {
    background-color: rgba(255, 166, 0, 0.2);
    color: #fff;
  }

  @media screen and (max-width: 900px) {
    ul.tabs__header {
      padding: 0.3rem;
      gap: 0.25rem;
    }

    ul.tabs__header > li {
      flex: 1 1 45%;
      text-align: center;
      padding-left: 0.75rem;
      padding-right: 0.75rem;
      font-size: 1rem;
    }
  }
</style>
